var tabs = document.getElementsByClassName('tablinks');
var seasons = document.getElementsByClassName('month-list');

for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', function() {
        for (let o = 0; o < seasons.length; o++) {
            seasons[o].classList.remove('active');
            tabs[o].classList.remove('active');
        }
        seasons[i].classList.add('active');
        tabs[i].classList.add('active');
    })
}